<template>
  <b-card v-if="data" class="card-congratulation-medal">
    <h5>{{ userData.name }}</h5>
    <b-card-text class="font-small-3">
      {{ userData.email }}
    </b-card-text>
    <h5 class="mb-75 mt-2 pt-50">
      Nomor Pendaftaran: <span v-if="userData.lembar_kehidupan.nomor_ujian">{{
        userData.lembar_kehidupan.nomor_ujian }}</span>
    </h5>
    <b-button @click="redirectToProfile" variant="warning">
      Lihat Profil Saya
    </b-button>
    <b-img :src="require('@/assets/images/pages/congratulations-john.png')" class="congratulation-medal" width="250"
      alt="Medal Pic" />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      userData: {},
    }
  },
  mounted() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
  },
  methods: {
    kFormatter,
    redirectToProfile() {
      this.$router.push('/lembar-kehidupan');
    }
  },
}
</script>
